import { Outlet } from "react-router-dom";

import { AppNav } from "./AppNav";
import { AppUpdatePrompt } from "./AppUpdatePrompt";
import { useResumeInApp } from "./useResumeInApp";

export function AppShell() {
  useResumeInApp();
  return (
    <div className="app-shell">
      <AppNav />
      <AppUpdatePrompt />
      <main className="app-main">
        <Outlet />
      </main>
    </div>
  );
}
